import React from 'react';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const Guidance = () => {
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.Guidance.s12',
    'Guidance for installers - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const page = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.Guidance.s1',
          'Guidance for installers'
        )}
      </h1>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('installer.Guidance.s2', 'New installers')}
      </h2>
      <p>
        {copyProvider.getCopy(
          'installer.Guidance.s3',
          'If you are a new installer, you will first need to apply to be an OZEV authorised installer before you can use this service.'
        )}
      </p>
      <p>
        {copyProvider.getCopy(
          'installer.Guidance.s4',
          'You will be redirected to a different service.'
        )}
      </p>
      <Button
        className="govuk-button"
        data-module="govuk-button"
        href="https://forms.dft.gov.uk/ozev-authorised-installer-application/"
      >
        {copyProvider.getCopy(
          'installer.Guidance.s5',
          'Apply to be an authorised installer'
        )}
      </Button>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('installer.Guidance.s6', 'Existing installers')}
      </h2>
      <p>
        {copyProvider.getCopy(
          'installer.Guidance.s7',
          'If you are an authorised installer, you can request a link to create a password and access this service for the first time.'
        )}
      </p>
      <p>{copyProvider.getCopy('installer.Guidance.s11', 'You will need:')}</p>
      <ul>
        <li>
          {copyProvider.getCopy(
            'installer.Guidance.s8',
            'The email address you have registered with OZEV'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'installer.Guidance.s9',
            'Your installer authorisation number'
          )}
        </li>
      </ul>
      <Button
        className="govuk-button"
        data-module="govuk-button"
        onClick={() => history.push('/installer/request-link-for-password')}
      >
        {copyProvider.getCopy(
          'installer.Guidance.s10',
          'Request link to create password'
        )}
      </Button>
    </>
  );
  return <div className="govuk-width-container govuk-body">{page}</div>;
};

export default Guidance;
